var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconWarranty({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 22,
    viewBox: "0 0 19 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.07625 4.35457L1.01575 4.38012M1.01575 4.38012L9.021 1L17.68 4.4264C16.5363 14.2209 14.5911 17.9748 9.021 21C2.67814 16.6101 0.804522 13.0501 1.01575 4.38012Z",
    stroke: "white",
    strokeWidth: 0.949239
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4169 8L8.4695 13.0635L6 10.5317",
    stroke: "white",
    strokeWidth: 1.06091,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWarranty);
export default __webpack_public_path__ + "static/media/iconWarranty.da8a3c66119257576ab9d89e58b4c194.svg";
export { ForwardRef as ReactComponent };